import { render, staticRenderFns } from "./ResearchOutputSensitivities.vue?vue&type=template&id=bef03032&scoped=true&"
import script from "./ResearchOutputSensitivities.vue?vue&type=script&lang=js&"
export * from "./ResearchOutputSensitivities.vue?vue&type=script&lang=js&"
import style0 from "./ResearchOutputSensitivities.vue?vue&type=style&index=0&id=bef03032&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef03032",
  null
  
)

export default component.exports